import { dataUserCardSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserCardSolid = /*#__PURE__*/createIcon(dataUserCardSolid)
export default IconUserCardSolid
